<template>
  <div class="md-layout ticket-wrapper">
    <div class="md-layout-item md-size-66">
      <md-field class="md-form-group" slot="inputs">
        <md-icon><i class="fas fa-tag text-primary hi-price-icon"></i></md-icon>
        <label>Ticket Title</label>
        <md-input v-model="localTicket.title" type="text"></md-input>
      </md-field>
    </div>
    <div class="md-layout-item md-size-33">
      <md-field class="md-form-group" slot="inputs">
        <md-icon
          ><i class="fas fa-ticket-alt text-primary hi-price-icon"></i
        ></md-icon>
        <label>Allocation</label>
        <md-input
          :readonly="!canEdit"
          type="number"
          v-model="localTicket.allocation"
        ></md-input>
      </md-field>
    </div>

    <div class="md-layout-item md-size-33">
      <md-field class="md-form-group" slot="inputs">
        <md-icon
          ><i class="fas fa-pound-sign text-primary hi-price-icon"></i
        ></md-icon>
        <label>GBP</label>
        <md-input v-model="localTicket.prices.gbp" type="text"></md-input>
      </md-field>
    </div>
    <div class="md-layout-item md-size-33">
      <md-field class="md-form-group" slot="inputs">
        <md-icon
          ><i class="fas fa-euro-sign text-primary hi-price-icon"></i
        ></md-icon>
        <label>EUR</label>
        <md-input v-model="localTicket.prices.eur" type="text"></md-input>
      </md-field>
    </div>
    <div class="md-layout-item md-size-33">
      <md-field class="md-form-group" slot="inputs">
        <md-icon
          ><i class="fas fa-dollar-sign text-primary hi-price-icon"></i
        ></md-icon>
        <label>USD</label>
        <md-input v-model="localTicket.prices.usd" type="text"></md-input>
      </md-field>
    </div>

    <div class="md-layout-item md-size-66 allocated-count">
      <md-icon
        ><i
          :class="allocation_state"
          class="fas fa-user-check hi-price-icon"
        ></i
      ></md-icon>
      <span style="margin-left:12px;">{{ allocated_count }}</span>
    </div>
    <div class="md-layout-item md-size-33 text-right">
      <md-button
        :disabled="!isDirty"
        class="md-just-icon md-simple md-success"
        @click.prevent="updateTicket(ticket)"
      >
        <md-icon>save</md-icon>
        <md-tooltip md-direction="top">Update this Ticket</md-tooltip>
      </md-button>
      <md-button
        class="md-just-icon md-simple md-danger"
        @click.prevent="removeTicket(ticket)"
      >
        <md-icon>remove_circle</md-icon>
        <md-tooltip md-direction="top">Remove this Ticket</md-tooltip>
      </md-button>
    </div>
  </div>
</template>
<script>
import confirm from "@/helpers/deleteConfirm";

export default {
  props: {
    ticket: Object
  },

  components: {},

  data() {
    return {
      isDirty: true,
      localTicket: structuredClone(this.ticket)
    };
  },

  methods: {
    updateTicket(ticket) {
      this.$emit("updateTicket", this.localTicket);
    },

    removeTicket(ticket) {
      confirm.delete(null).then(resp => {
        if (resp.value) {
          this.$emit("removeTicket", ticket);
        }
      });
    }
  },

  computed: {
    canEdit() {
      return true; // Placeholder for permission logic
    },
    allocated_count() {
      let allocated = this.ticket.allocated || 0;
      return (
        "(" +
        allocated +
        "/" +
        this.ticket.allocation +
        (allocated == 1 ? " Ticket" : " Tickets") +
        " Allocated)"
      );
    },
    allocation_state() {
      if (
        this.ticket.allocation === null ||
        this.ticket.allocation === undefined
      ) {
        return "fa-user-check text-primary";
      } else if (this.ticket.allocated >= this.ticket.allocation) {
        return "fa-user-check text-danger";
      } else {
        return "fa-user-check text-success";
      }
    }
  },

  watch: {
    ticket: {
      handler(nextTicket) {
        this.localTicket = structuredClone(nextTicket);
      },
      deep: true
    }
  }
};
</script>
<style lang="scss" scoped>
.ticket-wrapper {
  border: 1px solid #ddd;
  border-radius: 7px;
  background-color: #f6f6f6;
  margin-bottom: 1em;
  padding-top: 10px;
}

.allocated-count {
  align-items: center;
  padding-top: 12px;
  font-style: italic;
  font-size: 0.9em;
}

.price-row {
  margin-bottom: 1rem;
}

h6.title {
  display: flex;
  align-items: center;
}
</style>
